<template>
	<div class="ExternalSupplier">
		<!-- <el-button
			icon="el-icon-arrow-left"
			type="warning"
			style="width:auto;"
			size="mini"
			@click="$router.go(-1)"
		>
			Previous Page
		</el-button> -->
		<div
			style="border-bottom: 1px solid #000;padding-bottom: 10px;margin-bottom: 40px;"
		>
			<el-row :gutter="20" class="top-margin">
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Applicable to all Stores?</p>
					<el-checkbox
						v-model="applicableToAllStores"
						style="display: block;height: 40px; 5px;width: 100%;"
						:border="true"
						size="medium"
						true-label="all"
						false-label="none"
					>
						<p v-if="applicableToAllStores == 'all'">
							&nbsp;&nbsp;Yes
						</p>
						<p v-if="applicableToAllStores == 'none'">
							&nbsp;&nbsp;&nbsp;No
						</p>
					</el-checkbox>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">If Not Select Location</p>
					<div>
						<el-select
							v-model="locationsSelected"
							v-validate="applicableToAllStores === 'none' ? 'required' : ''"
							class="custom-input"
							style="width: 100%;"
							:disabled="applicableToAllStores == 'all'"
							multiple
							collapse-tags
							placeholder="Select"
							name="Locations"
						>
							<el-option
								v-for="(location, locationIndex) in locations"
								:key="locationIndex"
								:label="location.name"
								:value="location.id"
							/>
						</el-select>
						<span
							:v-show="errors.has('Locations')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Locations") }}
						</span>
					</div>
				</el-col>
				<!-- <el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<label>Choose Supplier</label>
					<div>
						<el-select
							v-model="supplier"
							v-validate="'required'"
							class="custom-input"
							style="width: 100%;"
							collapse-tags
							placeholder="Select"
							name="Supplier"
						>
							<el-option
								v-for="(supplierr, supplierIndex) in suppliers"
								:key="supplierIndex"
								:label="supplierr.name"
								:value="supplierr.id"
							/>
						</el-select>
						<span
							:v-show="errors.has('Supplier')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Supplier") }}
						</span>
					</div>
				</el-col> -->
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Order Created By:</p>
					<div>
						<el-select
							v-model="orderCreatedBy"
							v-validate="'required'"
							class="custom-input"
							style="width: 100%;"
							collapse-tags
							placeholder="Select"
							name="Order Created By"
						>
							<el-option label="Store" value="store" />
							<el-option label="Head Office" value="head_office" />
						</el-select>
						<span
							:v-show="errors.has('Order Created By')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Order Created By") }}
						</span>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="top-margin">
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Approval Required?</p>
					<el-checkbox
						v-model="approvalRequired"
						style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
						:border="true"
						size="medium"
						true-label="true"
						false-label="false"
					>
						<p v-if="approvalRequired == 'true'">
							&nbsp;&nbsp;Yes
						</p>
						<p v-if="approvalRequired == 'false'">
							&nbsp;&nbsp;&nbsp;No
						</p>
					</el-checkbox>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Approved By</p>
					<div>
						<el-select
							v-model="approvedBy"
							v-validate="approvalRequired === 'true' ? 'required' : ''"
							style="width: 100%;"
							collapse-tags
							multiple
							:disabled="approvalRequired == 'false'"
							placeholder="Select"
							class="custom-input"
							name="Approved By"
						>
							<el-option
								label="Store Manager"
								value="outlet"
							/>
							<el-option
								label="Regional Manager"
								value="region"
							/>
							<el-option
								label="Sub Regional Manager"
								value="sub_region"
							/>
						</el-select>
						<span
							:v-show="errors.has('Approved By')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Approved By") }}
						</span>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Approve Order By(Time)</p>
					<div class="custom-input">
						<el-time-picker
							v-model="approveOrderTime"
							v-validate="approvalRequired === 'true' ? 'required' : ''"
							:disabled="approvalRequired == 'false'"
							placeholder="Select time"
							style="width: 100%"
							value-format="HH:mm:ss"
							format="HH:mm:ss"
							name="Approve Order By"
						>
						</el-time-picker>
						<span
							:v-show="errors.has('Approve Order By')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Approve Order By") }}
						</span>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Auto Approval</p>
					<el-checkbox
						v-model="autoApproval"
						style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
						:border="true"
						:disabled="approvalRequired == 'false'"
						size="medium"
						true-label="true"
						false-label="false"
					>
						<p v-if="autoApproval == 'true'">
							&nbsp;&nbsp;Yes
						</p>
						<p v-if="autoApproval == 'false'">
							&nbsp;&nbsp;&nbsp;No
						</p>
					</el-checkbox>
				</el-col>
			</el-row>
		</div>
		<div
			style="border-bottom: 1px solid #000;padding-bottom: 10px;margin-bottom: 20px;"
		>
			<el-row :gutter="20" class="top-margin">
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Is the Account Already Created?</p>
					<div>
						<el-checkbox
							v-model="accountAlreadyCreated"
							style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
							:border="true"
							size="medium"
							true-label="true"
							false-label="false"
						>
							<p v-if="accountAlreadyCreated == 'false'">
								&nbsp;&nbsp;No
							</p>
							<p v-if="accountAlreadyCreated == 'true'">
								&nbsp;&nbsp;&nbsp;Yes
							</p>
						</el-checkbox>
					</div>
				</el-col>
				<el-col
					v-if="accountAlreadyCreated == 'false'"
					:xl="6"
					:lg="6"
					:md="6"
					:sm="12"
					:xs="24"
				>
					<p class="input-label">If Not</p>
					<div class="mb-4">
						<BaseButton
							buttonclass="btn p-2 text-sm mt-1"
							@click="$router.push('/account/add').catch(()=>{})"
						>
							Create Account First
						</BaseButton>
					</div>
				</el-col>
			</el-row>
			<div v-if="accountAlreadyCreated == 'true'">
				<div>
					<p style="border-bottom: 1px solid #ccc;margin-bottom: 5px;">
						Supplier
					</p>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
							<p class="input-label">Supplier Name</p>
							<div>
								<el-select
									v-model="supplierDetails.suppliersName"
									v-validate="
										accountAlreadyCreated === 'true' ? 'required' : ''
									"
									class="custom-input"
									style="width: 100%;"
									collapse-tags
									placeholder="Select"
									name="suppliersName"
									@change="getSupplireDetails"
								>
									<el-option
										v-for="(supplier, supplierIndex) in suppliers"
										:key="supplierIndex"
										:label="supplier.name"
										:value="supplier.id"
									/>
								</el-select>
								<span
									:v-show="errors.has('suppliersName')"
									class="text-red-dark text-xs"
								>
									{{ errors.first("suppliersName") }}
								</span>
							</div>
						</el-col>
						<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
							<p class="input-label">Supplier Id</p>
							<BaseInput
								v-model="supplierDetails.supplierId"
								class="custom-input"
								placeholder="Supplier Id"
							/>
						</el-col>
						<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
							<p class="input-label">Minimum Order</p>
							<BaseInput
								v-model="supplierDetails.minimumOrderAmount"
								v-validate="
									accountAlreadyCreated === 'true' ? 'required|numeric' : ''
								"
								class="custom-input"
								placeholder="Minimum Order"
								type="number"
								name="minimumOrder"
							/>
							<span
								:v-show="errors.has('minimumOrder')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("minimumOrder") }}
							</span>
						</el-col>
					</el-row>
				</div>
				<div>
					<p style="border-bottom: 1px solid #ccc;margin-bottom: 5px;">
						Contact
					</p>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
							<p class="input-label">Name</p>
							<BaseInput
								v-model="supplierDetails.userName"
								class="custom-input"
								placeholder="First Name"
							/>
						</el-col>
						<!-- <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
							<label>Last Name</label>
							<BaseInput class="custom-input" placeholder="Last Name" />
						</el-col> -->
						<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
							<p class="input-label">Email</p>
							<BaseInput
								v-model="supplierDetails.email"
								class="custom-input"
								placeholder="Email"
							/>
						</el-col>
						<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
							<p class="input-label">Alternate Email</p>
							<BaseInput class="custom-input" placeholder="Alternate Email" />
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
							<p class="input-label">Office Phone</p>
							<BaseInput class="custom-input" placeholder="Office Phone" />
						</el-col>
						<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
							<p class="input-label">Mobile</p>
							<BaseInput
								v-model="supplierDetails.phone"
								class="custom-input"
								placeholder="Mobile"
							/>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div
			style="border-bottom: 1px solid #000;padding-bottom: 10px;margin-bottom: 20px;"
		>
			<el-row :gutter="20" class="top-margin">
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p>Schedule For Order</p>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Order Anytime</p>
					<div>
						<el-checkbox
							v-model="orderAnytime"
							style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
							:border="true"
							size="medium"
							true-label="true"
							false-label="false"
						>
							<p v-if="orderAnytime == 'true'">
								&nbsp;&nbsp;Yes
							</p>
							<p v-if="orderAnytime == 'false'">
								&nbsp;&nbsp;&nbsp;No
							</p>
						</el-checkbox>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Delivery ETA</p>
					<div class="custom-input">
						<BaseInput
							v-model="deliveryETA"
							v-validate="'required'"
							style="-width: 100%;"
							class="baseInput"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Delivery ETA"
							name="Delivery ETA"
						/>
						<span
							:v-show="errors.has('Delivery ETA')"
							class="text-red-dark text-xs"
						>
							{{ errors.first("Delivery ETA") }}
						</span>
					</div>
				</el-col>
			</el-row>
			<div v-if="orderAnytime == 'false'">
				<BaseScheduleOrderTable :schedule-order="scheduleOrder" />
			</div>
		</div>
		<div>
			<p style="border-bottom: 1px solid #ccc;margin-bottom: 5px;">
				Add Products Supplied By Vendor
			</p>
			<el-row :gutter="20" class="top-margin">
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<div style="display:flex;" class="custom-input">
						<label class="btn p-2">
							Upload Csv
							<input
								id="productCsv"
								name="File Upload"
								accept=".csv"
								type="file"
								:disabled="showTable === true"
								@change="readCsv"
							/>
						</label>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<div class="custom-input">
						<BaseButton buttonclass="btn p-2 text-xs" @click="showAndHideTable">
							Add Products
						</BaseButton>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<div class="custom-input">
						<BaseButton
							buttonclass="btn p-2 text-xs"
							@click="showSavePopup = true"
						>
							Save
						</BaseButton>
					</div>
				</el-col>
			</el-row>
		</div>
		<BaseProductsTable
			v-if="showTable == true"
			:show-external-supplier-fields="true"
			:products="products"
			:show-table="showTable"
			:is-add-product-button="true"
			@deleteArticle="deleteArticle"
		/>
		<el-dialog
			:visible.sync="showSavePopup"
			width="50%"
			:before-close="handleClose"
		>
			<span
				>Do you Wish to save this supplier as Default supplier for the
				Catalog</span
			>
			<span slot="footer">
				<el-row :gutter="20" class="top-margin">
					<el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
						<el-checkbox
							v-model="isDefault"
							style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 200px; margin: 15px auto;text-align: left;"
							:border="true"
							size="medium"
							true-label="true"
							false-label="false"
						>
							<p v-if="isDefault == 'true'">
								&nbsp;&nbsp;Yes
							</p>
							<p v-if="isDefault == 'false'">
								&nbsp;&nbsp;&nbsp;No
							</p>
						</el-checkbox>
					</el-col>
					<el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
						<div class="custom-input" style="width: 200px;margin: 15px auto;">
							<BaseButton
								buttonclass="btn p-2 text-xs"
								@click="createExternalVendor"
							>
								Save Supplier
							</BaseButton>
						</div>
					</el-col>
				</el-row>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import AddSupplierDetails from "../addSupplierDetails/AddSupplierDetails.vue";
import { SuppliersMixin } from "../../../../../../mixins/suppliers.mixin";
// import { CommonMixin } from "../../../../../../mixins/common.mixin";
import { ExternalProductCsv } from "../../../../../../mixins/processCsvFunctions/externalProductCsv.mixin";
import { async, resolve, reject } from "q";
import CommonService from "../../../../../services/commonService";
import UserAccountsService from "../../../../../services/userAccountsService";
export default {
	name: "ExternalSupplier",
	components: {
		// AddSupplierDetails
	},
	mixins: [SuppliersMixin, ExternalProductCsv],
	props: [],
	data() {
		return {
			accountAlreadyCreated: "false",
			checked: "all",
			showSavePopup: false,
			orderAnytime: "false",
			isAccountCreated: "false",
			value: "",
			supplierDetails: {
				supplierName: "",
				supplierId: "",
				minimumOrderAmount: "",
				userName: "",
				email: "",
				phone: ""
			},
			csvProduct: [],
			approvedBy: []
		};
	},
	created() {
		this.getLocations({ get_all: true });
		this.getUsers({
			get_all: true,
			fields: ["id", "full_name", "last_name"]
		});

		this.sortSuppliers();
		//type vendor is require
	},
	methods: {
		readCsv(file) {
			console.log("file", file);
			this.readCsvFile(file.target.files[0]).then(data => {
				console.log("data in Exaternal suppier", data);
				this.processExternalProductCsv(data);
				if (!this.errorsInCsv.length) {
					// console.log("Exaternal suppier", data.data);
					var exaternalCsvData = [];
					for (var i = 0; i < data.data.length; i++) {
						var obj = {};
						for (var key in data.data[i]) {
							var text = [key.replace(/\s/g, "")];
							for (var j = 0, x = text.length; j < x; j++) {
								text[j] =
									text[j][0].toLowerCase() +
									text[j]
										.substr(1)
										.split("(")[0]
										.split("%")[0];
								// text[j] = text[j].split("(")[0];
								// text[j] = text[j].split("%")[0];
							}
							obj[text] = data.data[i][key];
							// obj[key.replace(/\s/g, "")] = data.data[i][key];
						}
						exaternalCsvData.push(obj);
					}
					console.log("exaternalCsvData", exaternalCsvData);
					this.csvProduct = exaternalCsvData;
					// this.uploadCsv(file);
				} else {
					window.localStorage.setItem(
						"errorsInCsv",
						JSON.stringify(this.errorsInCsv)
					);

					window.open(this.$route.path, "_blank");
					// this.dialogVisible = true;
				}
			});
		},
		async sortSuppliers() {
			await this.getVendors();
			await this.getSuppliers({
				//type should not be a store user
				get_all: true,
				type: "vendor"
			});
			const vendorIdList = this.vendors.map(vendor => vendor.account);
			this.suppliers = this.suppliers.filter(
				supplier => vendorIdList.indexOf(supplier.id) === -1
			);
		},
		showAndHideTable() {
			if (this.showTable === true) {
				this.showTable = false;
			} else {
				this.showTable = true;
				var element = document.getElementById("productCsv");
				element.onclick = event => {
					// console.log("event.target.value", event.target.value);
					// console.log("this.", this);
					event.target.value = null;
				};
			}
		},
		async createExternalVendor() {
			const validationResult = await this.$validator
				.validateAll()
				.then(result => result);

			if (validationResult) {
				try {
					var vendorId = await this.createVendor({
						account: this.supplierDetails.suppliersName,
						type: "external",
						order_created_by: this.orderCreatedBy,
						approval_required: this.approvalRequired === "true" ? true : false,
						approved_by: this.approvedBy,
						approve_before: this.approveOrderTime || null,
						auto_approval: this.autoApproval === "true" ? true : false,
						schedule:
							this.orderAnytime === "true"
								? this.scheduleOrder
										.filter(schedule => schedule.day !== "")
										.reduce((acc, v) => {
											acc[v["day"]] = v["untill"];
											return acc;
										}, {})
								: {},
						supplied_stores:
							this.applicableToAllStores === "all"
								? this.locations.map(location => location.id)
								: this.locationsSelected,
						is_default: this.isDefault === "true" ? true : false,
						order_anytime: this.orderAnytime === "true" ? true : false,
						eta: Number(this.deliveryETA),
						minimum_order_amount: Number(
							this.supplierDetails.minimumOrderAmount
						)
					}).then(response => {
						console.log("respnse in createExternal", response);
						if (response.status === 201) {
							this.$notify.success({
								title: "Success",
								message: "Vendor Created"
							});
							return resolve(JSON.parse(response.data).id);
						} else return reject(false);
					});
				} catch (err) {
					console.log(err);
					this.$notify.error({
						title: "Fail",
						message: "Something Went Wrong"
					});
				}

				if (vendorId) {
					try {
						await this.createVendorSupplies({
							vendorId: vendorId,
							params: this.products
								.filter(product => product.itemName !== "")
								.map(product => {
									return {
										article: product.itemName,
										order_unit: product.orderUnit,
										order_unit_conversion: product.contains,
										weightable: product.weightable,
										minimum_order: product.minimumOrder,
										deposit: product.deposit,
										tax: product.tax,
										order_unit_cost: product.orderUnitCost,
										base_unit_cost: product.baseUnitCost
									};
								})
						}).then(response => {
							if (response.status === 201) {
								this.$notify.success({
									title: "Success",
									message: "Supplies Created"
								});
								return resolve(JSON.parse(response.data).id);
							} else return reject(false);
							console.log("response in createVendorSupplies", response);
						});
					} catch (err) {
						console.log(err);
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong in supplies"
						});
					}
				}
			}
			this.showSavePopup = false;
		},
		async getSupplireDetails(supplierId) {
			await UserAccountsService.getOutlet(supplierId).then(response => {
				console.log(JSON.parse(response.data));
				const supplier = JSON.parse(response.data);
				this.supplierDetails.supplierId = supplier.id;
				this.supplierDetails.email = supplier.email;
				this.supplierDetails.phone = supplier.phone;
			});
			this.getUserData({ get_all: true });
		},
		async getUserData() {
			await CommonService.getLoggedinUserData().then(response => {
				const userName = response;
				this.supplierDetails.userName =
					userName.full_name;
			});
		},
		handleClose() {
			this.showSavePopup = false;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./ExternalSupplier.scss";
</style>
<style>
.ExternalSupplier .el-button--primary {
	background-color: #e29d5a !important;
	border-color: #e29d5a;
}
</style>
